// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hNmz","field":"styles_field__jvGUS","fieldCol":"styles_fieldCol__119B7","diffCol":"styles_diffCol__CudeD","diff":"styles_diff__34jjo"};